module.exports = __webpack_public_path__ + "img/img19.4e514fd5.png";